import React, { useEffect } from "react";
import RadioInput from "../inputs/RadioInput";

const Radio = ({ register, error, field, id, watch, setValue }) => {
	const validate = (value) => {
		if (field.required) {
			if (!value) {
				return "This field is required";
			}
		}
		return true;
	};

	return (
		<div className="field__checkbox-group">
			<RadioInput
				options={field.options.map((option) => ({
					value: option.value,
					label: option.label,
				}))}
				id={id}
				validate={validate}
				error={error}
				label={field.label}
				required={field.required}
				register={register}
			/>
		</div>
	);
};

export default Radio;
